import apiClient from './apiClient';
import { getAccessToken } from '../lib/auth';

export interface TaxReport {
  reportType: string;
  startDate: string;
  endDate: string;
  ownerId: number;
  ownerName: string;
  ownerEmail: string;
  totalRentIncome: number;
  totalBondIncome: number;
  otherIncome: number;
  totalIncome: number;
  maintenanceExpenses: number;
  repairExpenses: number;
  agentFeesExpenses: number;
  insuranceExpenses: number;
  councilRatesExpenses: number;
  waterRatesExpenses: number;
  advertisingExpenses: number;
  legalExpenses: number;
  otherExpenses: number;
  totalExpenses: number;
  netIncome: number;
  gstCollected: number;
  gstPaid: number;
  netGst: number;
}

const taxApi = {
  // Generate custom date range report
  getReport: (startDate: string, endDate: string, reportType: string = 'CUSTOM') =>
    apiClient.get<TaxReport>(
      `/tax/report?startDate=${startDate}&endDate=${endDate}&reportType=${reportType}`
    ),

  // Generate quarterly BAS summary
  getQuarterlyBAS: (year: number, quarter: number) =>
    apiClient.get<TaxReport>(`/tax/bas/quarterly?year=${year}&quarter=${quarter}`),

  // Generate annual tax report
  getAnnualReport: (financialYear: number) =>
    apiClient.get<TaxReport>(`/tax/report/annual?financialYear=${financialYear}`),

  // Export as CSV
  exportCSV: async (startDate: string, endDate: string): Promise<string> => {
    const baseURL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8787/api';
    const response = await fetch(
      `${baseURL}/tax/report/export/csv?startDate=${startDate}&endDate=${endDate}`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.text();
  },
};

export default taxApi;

